<div>
  <img src="assets/no-data-found.svg" alt="Sin resultados">
  <p style="font-size: small; font-weight: bold;">No hay resultados que coincida con la b&uacute;squeda </p>
  <p style="font-size: small;">Int&eacute;ntalo de nuevo usando t&eacute;rminos de b&uacute;squeda m&aacute;s generales</p>
</div>
